import { render } from "./DashboardSummarySection.vue?vue&type=template&id=18b86c63&scoped=true"
import script from "./DashboardSummarySection.vue?vue&type=script&lang=js"
export * from "./DashboardSummarySection.vue?vue&type=script&lang=js"

import "./DashboardSummarySection.vue?vue&type=style&index=0&id=18b86c63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b86c63"]])

export default __exports__